import {GetMapping, PostMapping, QueryMap, RequestBody, RequestMapping2Class, RequestParam} from "../http";
import CategoryDefaultDto from "./model/category/CategoryDefaultDto";


@RequestMapping2Class("/category")
class CategoryController {

    @GetMapping("/categoryDefault")
    categoryDefault(@RequestParam("categoryId")categoryId:number):Promise<CategoryDefaultDto>{throw 1}

}
const categoryController = new CategoryController();
export { categoryController };

